import { render } from "./ShowcaseHome.vue?vue&type=template&id=082cf24b&scoped=true&ts=true"
import script from "./ShowcaseHome.vue?vue&type=script&lang=ts"
export * from "./ShowcaseHome.vue?vue&type=script&lang=ts"

import "./ShowcaseHome.vue?vue&type=style&index=0&id=082cf24b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082cf24b"]])

export default __exports__